const TipoIntegracaoLogin = {
  BUILT_IN: 'BUILT_IN',
  SEBRAE_PR_SAS_API: 'SEBRAE_PR_SAS_API'
};

export default TipoIntegracaoLogin;
